import { MS_IN_SECOND } from "libs/date-helpers";
import { Simplify } from "type-fest";

export interface UndoRedoEntry {
  forward: () => unknown;
  backward: () => unknown;
}

export type UndoRedoStackApi = Simplify<UndoRedoStack>;

export class UndoRedoStack {
  /** How many ms after a change that you undo it */
  undoWindow = MS_IN_SECOND * 10;
  running = false;
  undoStack: UndoRedoEntry[] = [];
  redoStack: UndoRedoEntry[] = [];

  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  resetUndoWindow() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      this.undoStack = [];
      this.redoStack = [];
      this.timeoutId = null;
    }, this.undoWindow);
  }
}
